import React, {useEffect, useRef, useState} from 'react';
import { useStyles } from "./styles/EduContentsControlStyle";
import {
    Box,
    Button,
    Typography,
    MenuItem,
    Popover, MenuList, CircularProgress
} from "@material-ui/core";
import { ReactComponent as DownloadIcon } from '../../../../common/images/DownloadIcon.svg';
import { ReactComponent as UploadIcon } from '../../../../common/images/UploadIcon.svg';
import clsx from "clsx";
import {EXCEL_UTIL} from "../../../../common/util/excel/excel.util";
import {inject, observer} from "mobx-react";
import {DIALOG_TYPES} from "../../../../common/enums/DialogTypes";
import {UploadType} from "../../../../common/enums/ExcelEnum";
import {injectIntl} from "react-intl";

function EduContentsControlButton(props) {
    const classes = useStyles();
    const {excelStore, summaryContentStore} = props;
    const [anchorEl, setAnchorEl] = useState(null);
    const [downloading, setDownloading] = useState(false);
    const excelRef =  useRef(null);
    const open = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;
    const {intl} = props;

    const handleClickExcelUpload = (event) => {
        setAnchorEl(event.currentTarget);
    };
    //
    // const openFileSearch = () => {
    //     console.log("openFileSearch");
    //     if (excelRef && excelRef.current) {
    //         console.log(" excel ref exists");
    //         excelRef.current.value = null;
    //     }
    //     props.excelStore.changeUploadContentState(false);
    //
    // }

    const uploadExcelFile = async (e) => {
        console.log("📘 uploadExcelFile");
        await bringExcelInfoAfterUpload(e);
        //TODO 임시 엑셀 파일 업로드 주석
    }
    const bringExcelInfoAfterUpload =  (e) => {
        console.log("📘 bringExcelInfoAfterUpload");
        if (e.target.files[0]) {
            const file = e.target.files[0];
            EXCEL_UTIL.uploadExcelFile(file,UploadType.ALL,checkExcelFileSheet);
        }
    }

    const checkExcelFileSheet = (result) => {
        excelStore.requestToCheckForExistingContents(result,EXCEL_UTIL.getSheetInfo(),actionAfterCheckingForExistingContent);
    }
    const actionAfterCheckingForExistingContent = (bool,content,list) => {
        if (bool)  {
            openAskToContinueDialog(content,list);
        } else  {
            requestUploadContent(content,list);
        }
    }
    const openAskToContinueDialog = (content,list) => {
        props.dialogStore.openNewDialog({
            titleText:'',
            text:'이미 등록된 데이터가 있습니다. 덮어 쓰시겠습니까?',
            controlBtn:true,
            clickButton: () => requestUploadContent(content,list),
            controlBtnText:'확인',
            additionalActionOnClose:()=>EXCEL_UTIL.initExcelData()
        });
    }
    const requestUploadContent = (content,list) => {
        excelStore.manageToRequest(content,list);
        props.dialogStore.openNewDialog({
            titleText: "컨텐츠 업로드",
            contentType: DIALOG_TYPES.EXCEL_UPLOAD_ALL,
            additionalActionOnClose:()=>EXCEL_UTIL.initExcelData()
        });
    }


    const handleCloseExcelUpload = () => {
        setAnchorEl(null);
    };

    const uploadExcelByStepAndDay = () => {
        excelStore.initStepAndDayValue();
        console.log("📘 : uploadExcelByStepAndDay ");
        const dialogInfo = {
            titleText: "컨텐츠 업로드",
            contentType: DIALOG_TYPES.EXCEL_UPLOAD_PART,
            text: "",
            controlBtn: true,
            clickButton: stepDaySelectComponent,
            controlBtnText: "등록",
            disabledButton: false,
            additionalActionOnConfirm: () => props.excelStore.changeUploadContentState(true),
            additionalActionOnClose: initWhenCloseDialogForStepDayUpload,
        }
        props.dialogStore.openNewDialog(dialogInfo);
    }
    const initWhenCloseDialogForStepDayUpload = () => {
        EXCEL_UTIL.initExcelData();
        excelStore.initStepAndDayValue();
    }

    const stepDaySelectComponent = async () => {
        console.log(`📗 : )   step : ${props.excelStore.stepValue} Day: ${props.excelStore.dayValue}`);
    }

    useEffect(() => {
        if (props.excelStore.isReadyToUploadContent) {
            let input = document.getElementById('excelUpload');
            input.click();
            props.excelStore.changeUploadContentState(false);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.excelStore.isReadyToUploadContent]);

    const handleClickFinalTestUpload = () => {
        const input = document.getElementById('finalTestUpload');
        input.click();
    }

    const uploadFinalTestFile = (e) => {
        const file = e.target.files[0];
        if (file) {
            excelStore.uploadFinalTest(file);
        }
        e.target.value = '';
    }

    return (
        <Box display='flex' alignItems='center'>
            <Button className={classes.buttonStyle}
                    disabled={summaryContentStore.summaryContentList.length === 0 || downloading}
                    onClick={() => {
                        setDownloading(true);
                        excelStore.contentExcelDownload(() => setDownloading(false));
                    }}
                    disableRipple
            >
                {
                    downloading ?
                        <CircularProgress size={20}/> :
                        <>
                            <DownloadIcon/>
                            <Typography>{intl.formatMessage({id: "excelDownload"})}</Typography>
                        </>
                }
            </Button>
            <Button
                className={clsx(classes.buttonStyle, classes.buttonStyle2)}
                aria-describedby={id}
                onClick={handleClickExcelUpload}
                disableRipple
            >
                <UploadIcon/>
                <Typography>{intl.formatMessage({id: "excelUpload"})}</Typography>
            </Button>
            <Button
                className={clsx(classes.buttonStyle, classes.buttonStyle2)}
                aria-describedby={id}
                onClick={handleClickFinalTestUpload}
                disableRipple
            >
                <UploadIcon/>
                <input id={'finalTestUpload'} style={{ display: 'none' }} accept={".xlsx, .xls"} onChange={uploadFinalTestFile} type={'file'}/>
                <Typography>{intl.formatMessage({id: "finalTestUpload"})}</Typography>
            </Button>
            <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleCloseExcelUpload}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'center',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                className={classes.popoverBox}
            >
                <MenuList>
                    <MenuItem
                        // onClick ={openFileSearch}
                        disableRipple>
                        <input ref={excelRef} onChange={uploadExcelFile}  placeholder={'전체 파일'} type={'file'} accept={".xlsx, .xls"} style={{ display: 'none' }}/>
                        전체 파일
                    </MenuItem>
                    <MenuItem disableRipple onClick = {uploadExcelByStepAndDay}>
                        Step / Day 선택
                    </MenuItem>
                </MenuList>
            </Popover>
        </Box>
    );
}

export default
    inject('excelStore','summaryContentStore','dialogStore')(
        injectIntl(observer(EduContentsControlButton))
    );
